export default __webpack_public_path__ + "static/media/köide-17-18.02874ba5.png";